import { toSentence } from 'Data/format'

export function getText(locations) {
  return `The configuration will apply for the following locations as they share the same Payabli Account ID: ${toSentence(
    locations.map(item => item.location.name)
  )}`
}
